import { render, staticRenderFns } from "./company-detail.vue?vue&type=template&id=268c7de6&scoped=true&"
import script from "./company-detail.vue?vue&type=script&lang=js&"
export * from "./company-detail.vue?vue&type=script&lang=js&"
import style0 from "./company-detail.vue?vue&type=style&index=0&id=268c7de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268c7de6",
  null
  
)

export default component.exports